import { PrivateMessagesProvider } from './../../providers/PrivateMessages'

export const OPEN_MESSAGE_BOX = '[messageUser] message box opened'
export const CLOSE_MESSAGE_BOX = '[messageUser] message box closed'
export const SEND_SUCCESS = '[messageUser] successfully sent a private message'
export const SEND_FAILED = '[messageUser] failed to send a private message'

export const openMessageBox = () => ({ type: OPEN_MESSAGE_BOX })

export const closeMessageBox = () => ({ type: CLOSE_MESSAGE_BOX })

export const sendMessage = (msg, to) => dispatch => {
  const provider = new PrivateMessagesProvider()

  provider
    .send(msg, to)
    .then(() => dispatch({ type: SEND_SUCCESS }))
    .catch(e => dispatch({ type: SEND_FAILED, e }))
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/messageUser/MessageUser.actions.js